import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Heart, Link2, Plus, Settings, Users } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import ListaBodas from '../components/bodas/admin/ListaBodas';
import TablaSolicitudes from '../components/bodas/admin/TablaSolicitudes';
import EnlacesClientes from '../components/bodas/admin/EnlacesClientes';
import AjustesBodas from '../components/bodas/admin/AjustesBodas';
import { PCT_REFERIDO, PUNTOS_REFERIDO } from '../components/bodas/bodasUtils';

const PESTANAS = [
  { id: 'bodas', label: 'Bodas', corto: 'Bodas', icon: Heart },
  { id: 'solicitudes', label: 'Invitados y referidos', corto: 'Invitados', icon: Users },
  { id: 'enlaces', label: 'Enlaces de clientes', corto: 'Enlaces', icon: Link2 },
  { id: 'ajustes', label: 'Ajustes', corto: 'Ajustes', icon: Settings, soloGestion: true },
];

export default function BodasAdmin() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const gestiona = ['gerencia', 'admin'].includes(user?.role);
  const pestanas = PESTANAS.filter(p => gestiona || !p.soloGestion);
  const activa = pestanas.some(p => p.id === params.get('tab')) ? params.get('tab') : 'bodas';

  return (
    <div className="min-h-screen bg-slate-50" data-testid="bodas-admin-page">
      <header className="sticky top-0 z-10 bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-4">
          <div className="flex min-w-0 items-center gap-3">
            <button onClick={() => navigate('/dashboard')} className="rounded-lg p-2 transition hover:bg-slate-100" aria-label="Volver" data-testid="bodas-volver"><ArrowLeft className="h-5 w-5" /></button>
            <div className="min-w-0">
              <h1 className="flex items-center gap-2 text-xl font-bold text-slate-800"><Heart className="h-6 w-6 text-rose-500" />Bodas y Referidos</h1>
              <p className="text-sm text-slate-500">Invitados y referidos reciben {PCT_REFERIDO}% en su primera compra; quien los trae gana {PUNTOS_REFERIDO} Puntos JPM.</p>
            </div>
          </div>
          {gestiona && (
            <button onClick={() => navigate('/admin/bodas/nueva')} className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-2 font-medium text-white transition hover:bg-slate-700" data-testid="bodas-nueva">
              <Plus className="h-4 w-4" />Nueva boda
            </button>
          )}
        </div>
        <nav className="mx-auto flex max-w-7xl px-4 sm:gap-1" data-testid="bodas-pestanas">
          {pestanas.map(({ id, label, corto, icon: Icon }) => (
            <button key={id} onClick={() => setParams({ tab: id })} data-testid={`bodas-tab-${id}`}
              className={`inline-flex flex-auto items-center justify-center gap-1.5 whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors sm:flex-none sm:gap-2 sm:px-3 ${activa === id ? 'border-slate-800 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
              <Icon className="h-4 w-4 shrink-0" />
              <span className="sm:hidden">{corto}</span>
              <span className="hidden sm:inline">{label}</span>
            </button>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        {activa === 'bodas' && <ListaBodas gestiona={gestiona} />}
        {activa === 'solicitudes' && <TablaSolicitudes gestiona={gestiona} />}
        {activa === 'enlaces' && <EnlacesClientes />}
        {activa === 'ajustes' && <AjustesBodas />}
      </main>
    </div>
  );
}
